import isInPosDevice from "./isInPosDevice"

const isCloudPosPaymentRequest = (cashTypes = []) => {
  const isPosPaymentSelected =
    cashTypes.some(cashType =>
      cashType.isTerminal &&
      cashType.terminalName !== "pcPos"
    )

  return !isInPosDevice() && isPosPaymentSelected
}

export default isCloudPosPaymentRequest